import * as Types from '../../constants/actionTypes';

export default (state = {}, action) => {
    switch (action.type) {
        case Types.CURRENT_CLIENT:
            return {
                ...state,
                currentClient: action.data
            }
        default:
            return state
    }
}